import { navBarConfigActionType } from '../../actionTypes';

const initialState = {
  titleText: '',
  showBackBtn: true,
  showDesktopNavMenu: false,
  showDesktopSearchBar: false,
  showMobileSearchIcon: false,
};

const navBarConfig = (state = initialState, action) => {
  switch (action.type) {
    case navBarConfigActionType.SET_CONFIG:
      return {
        ...state,
        titleText: action.payload.titleText
          ? action.payload.titleText
          : state.titleText,
        showBackBtn:
          action.payload.showBackBtn === undefined
            ? state.showBackBtn
            : action.payload.showBackBtn,
        showDesktopNavMenu:
          action.payload.showDesktopNavMenu === undefined
            ? state.showDesktopNavMenu
            : action.payload.showDesktopNavMenu,
        showDesktopSearchBar:
          action.payload.showDesktopSearchBar === undefined
            ? state.showDesktopSearchBar
            : action.payload.showDesktopSearchBar,
        showMobileSearchIcon:
          action.payload.showMobileSearchIcon === undefined
            ? state.showMobileSearchIcon
            : action.payload.showMobileSearchIcon,
      };

    case navBarConfigActionType.RESET:
      if (action.payload.isNavMenuConfig) {
        return {
          ...initialState,
          showDesktopNavMenu: true,
          showBackBtn: false,
        };
      }
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default navBarConfig;



// WEBPACK FOOTER //
// ./reducer/navBarConfig/index.js